export enum ProductsSearchModeEnum {
    AllCollections = "AllCollections",
    CollectionGroup = "CollectionGroup",
    Collection = "Collection"
}
